const finishMessage = {
    add_success: {
        'zh-tw': "新增成功",
        en: "Add Successful",
    },
    modify_success: {
        'zh-tw': "修改成功",
        en: "Modify Successful",
    },
    delete_success: {
        'zh-tw': "刪除成功",
        en: "Delete Successful",
    },
    add_failure: {
        'zh-tw': "新增失敗",
        en: "Add Failure",
    },
    modify_failure: {
        'zh-tw': "修改失敗",
        en: "Modify Failure",
    },
    delete_failure: {
        'zh-tw': "刪除失敗",
        en: "Delete Failure",
    },
    please_select_item: {
        'zh-tw': "請選擇",
        en: "Please select an item",
    },
    please_input_item: {
        'zh-tw': "請輸入",
        en: "Please select an item",
    },
}

const authorized_category_management = {
    'zh-tw': "授權值分類管理",
    en: "Authorized Category Management",
    children: {
        ...finishMessage,
        authorized_values_management: {
            'zh-tw': "授權值管理",
            en: "Authorized Values Management"
        },
        category: {
            'zh-tw': "類別",
            en: "Category",
        },
        description: {
            'zh-tw': "描述",
            en: "Description",
        },
        add: {
            'zh-tw': "新增",
            en: "Add",
        },
        authorized_values: {
            'zh-tw': "授權值",
            en: "Authorized Values",
        },
        new_category: {
            'zh-tw': "新增授權值類別",
            en: "New Category",
        },
        authorised_value: {
            'zh-tw': "授權值",
            en: "Authorised Value",
        },
        description_opac: {
            'zh-tw': "描述（OPAC）",
            en: "Description (OPAC)",
        },
        library_information: {
            'zh-tw': "圖書館資訊",
            en: "Library Information",
        },
        delete: {
            'zh-tw': "刪除",
            en: "Delete",
        },
        edit: {
            'zh-tw': "編輯",
            en: "Edit",
        },
        cancel: {
            'zh-tw': "取消",
            en: "Cancel",
        },
        show_category: {
            'zh-tw': "顯示類別",
            en: "Show Category",
        },
        library_limitations: {
            'zh-tw': "圖書館限制",
            en: "Library Limitations",
        }
    }
}
const authorized_category_values_management = {
    'zh-tw': "授權值管理",
    en: "Authorized Category Values Management",
    children: {
        ...finishMessage,
        authorized_values_management: {
            'zh-tw': "授權值管理",
            en: "Authorized Values Management"
        },
        category: {
            'zh-tw': "類別",
            en: "Category",
        },
        description: {
            'zh-tw': "描述",
            en: "Description",
        },
        add: {
            'zh-tw': "新增",
            en: "Add",
        },
        authorized_values: {
            'zh-tw': "授權值",
            en: "Authorized Values",
        },
        new_category: {
            'zh-tw': "新增授權值類別",
            en: "New Category",
        },
        authorised_value: {
            'zh-tw': "授權值",
            en: "Authorised Value",
        },
        description_opac: {
            'zh-tw': "描述（OPAC）",
            en: "Description (OPAC)",
        },
        library_information: {
            'zh-tw': "圖書館資訊",
            en: "Library Information",
        },
        delete: {
            'zh-tw': "刪除",
            en: "Delete",
        },
        edit: {
            'zh-tw': "編輯",
            en: "Edit",
        },
        cancel: {
            'zh-tw': "取消",
            en: "Cancel",
        },
        show_category: {
            'zh-tw': "顯示類別",
            en: "Show Category",
        },
        library_limitations: {
            'zh-tw': "圖書館限制",
            en: "Library Limitations",
        }
    }
}
const library = {
    'zh-tw': "分館管理",
    en: "library",
    children: {
        ...finishMessage,
        branchcode: {
            'zh-tw': "分館代碼",
            en: "Branch Code",
        },
        branchname: {
            'zh-tw': "分館名稱",
            en: "Branch Name",
        },
        branchaddress1: {
            'zh-tw': "地址",
            en: "Branch Address ",
        },
        branchaddress2: {
            'zh-tw': "地址2",
            en: "Branch Address 2",
        },
        branchaddress3: {
            'zh-tw': "地址3",
            en: "Branch Address 3",
        },
        branchzip: {
            'zh-tw': "郵遞區號",
            en: "Branch ZIP",
        },
        branchcity: {
            'zh-tw': "縣市",
            en: "Branch City",
        },
        branchstate: {
            'zh-tw': "州/省",
            en: "Branch State",
        },
        branchcountry: {
            'zh-tw': "國家",
            en: "Branch Country",
        },
        branchphone: {
            'zh-tw': "電話",
            en: "Branch Phone",
        },
        branchfax: {
            'zh-tw': "傳真",
            en: "Branch Fax",
        },
        branchemail: {
            'zh-tw': "電子郵件",
            en: "Branch Email",
        },
        branchillemail: {
            'zh-tw': "館際互借電子郵件",
            en: "Branch ILL Email",
        },
        branchreplyto: {
            'zh-tw': "回覆至電子郵件",
            en: "Branch Reply-To Email",
        },
        branchreturnpath: {
            'zh-tw': "分館回覆路徑",
            en: "Branch Return Path",
        },
        branchurl: {
            'zh-tw': "分館網址",
            en: "Branch URL",
        },
        issuing: {
            'zh-tw': "是否使用中",
            en: "Issuing",
        },
        branchip: {
            'zh-tw': "IP 位址",
            en: "Branch IP",
        },
        geolocation: {
            'zh-tw': "地理位置",
            en: "Geolocation",
        },
        branchnotes: {
            'zh-tw': "備註",
            en: "Branch Notes",
        },
        marcorgcode: {
            'zh-tw': "MARC 機構代碼",
            en: "MARC Org Code",
        },
        pickup_location: {
            'zh-tw': "可供預約提取的地點",
            en: "Pickup Location",
        },
        public: {
            'zh-tw': "是否公開",
            en: "Public",
        },
        opacuserjs: {
            'zh-tw': "OPAC 使用者 JavaScript",
            en: "OPAC User JavaScript",
        },
        opacusercss: {
            'zh-tw': "OPAC 使用者 CSS",
            en: "OPAC User CSS",
        },
        yes: {
            'zh-tw': "是",
            en: "yes",
        },
        no: {
            'zh-tw': "否",
            en: "no",
        }
    }
}
const item_types_management = {
    'zh-tw': "館藏分類管理",
    en: "library",
    children: {
        ...finishMessage,
        itemtype: {
            'zh-tw': "項目類型",
            en: "Item Type",
        },
        parent_type: {
            'zh-tw': "父類型",
            en: "Parent Type",
        },
        description: {
            'zh-tw': "描述",
            en: "Description",
        },
        rentalcharge: {
            'zh-tw': "租金",
            en: "Rental Charge",
        },
        rentalcharge_daily: {
            'zh-tw': "每日租金",
            en: "Rental Charge Daily",
        },
        rentalcharge_daily_calendar: {
            'zh-tw': "每日租金（日曆）",
            en: "Rental Charge Daily Calendar",
        },
        rentalcharge_hourly: {
            'zh-tw': "每小時租金",
            en: "Rental Charge Hourly",
        },
        rentalcharge_hourly_calendar: {
            'zh-tw': "每小時租金（日曆）",
            en: "Rental Charge Hourly Calendar",
        },
        defaultreplacecost: {
            'zh-tw': "預設替換費用",
            en: "Default Replace Cost",
        },
        processfee: {
            'zh-tw': "處理費(遺失時)",
            en: "Process Fee (when lost)",
        },
        notforloan: {
            'zh-tw': "不外借",
            en: "Not for Loan",
        },
        imageurl: {
            'zh-tw': "圖片URL",
            en: "Image URL",
        },
        summary: {
            'zh-tw': "摘要",
            en: "Summary",
        },
        checkinmsg: {
            'zh-tw': "借還訊息",
            en: "Check-in Message",
        },
        checkinmsgtype: {
            'zh-tw': "借還訊息類型",
            en: "Check-in Message Type",
        },
        alert: {
            'zh-tw': "警告",
            en: "Alert",
        },
        message: {
            'zh-tw': "訊息",
            en: "Message",
        },
        sip_media_type: {
            'zh-tw': "SIP 媒體類型",
            en: "SIP Media Type",
        },
        hideinopac: {
            'zh-tw': "在 OPAC 隱藏",
            en: "Hide in OPAC",
        },
        searchcategory: {
            'zh-tw': "搜尋類別",
            en: "Search Category",
        },
        automatic_checkin: {
            'zh-tw': "自動借還",
            en: "Automatic Check-in",
        },
        branches: {
            'zh-tw': "分館限制",
            en: "Branches",
        },
        all_select: {
            'zh-tw': "全選",
            en: "All",
        },

        open: {
            'zh-tw': "開啟",
            en: "Open",
        },
        close: {
            'zh-tw': "關閉",
            en: "Close",
        },
        options_defined_by_itemtypecat: {
            'zh-tw': "選項由授權值 ITEMTYPECAT 定義。",
            en: "Options are defined by the authorized value ITEMTYPECAT.",
        },
        no_issue_option: {
            'zh-tw': "如果開啟，則無法借出此類型的任何館藏。如果未開啟，則此類型的每件館藏均可借出，除非特定館藏設置了不外借。",
            en: "If checked, no item of this type can be issued. If not checked, every item of this type can be issued unless notforloan is set for a specific item.",
        },
        automatic_checkin_option: {
            'zh-tw': "如果開啟，館藏在到期日後將自動歸還。此功能需要執行 misc/cronjobs/automatic_checkin.pl 排程作業。請聯繫系統管理員安排此作業。",
            en: "If checked, items will be automatically checked in once they've reached their due date. This feature requires the misc/cronjobs/automatic_checkin.pl cronjob. Ask your system administrator to schedule it.",
        },
        hide_in_opac_description: {
            'zh-tw': "若開啟，此類型的館藏項目將在 OPAC 的進階搜尋中被隱藏作為篩選條件。",
            en: "If checked, items of this type will be hidden as filters in OPAC's advanced search.",
        },
        checkout_renewal_fee: {
            'zh-tw': "此費用為每次借閱/續借每件館藏收取一次的費用。",
            en: "This fee is charged once per checkout/renewal per item.",
        },
        daily_fee_description: {
            'zh-tw': "此費用在借閱/續借時依據從借閱/續借日期到到期日期的每日收取，適用於以天為單位的借閱期限。",
            en: "This fee is charged at checkout/renewal time for each day between the checkout/renewal date and due date for loans specified in days.",
        },
        daily_charge_calendar_description: {
            'zh-tw': "若勾選，日費將使用日曆排除假期進行計算。若未勾選，費用將根據到期日之前的天數直接計算。",
            en: "If checked, daily charge will be calculated using the calendar to exclude holidays. If not checked, the fee will be calculated based on the number of days until due, directly.",
        },
        hourly_fee_description: {
            'zh-tw': "此費用在借閱/續借時依據從借閱/續借日期到到期日期的每小時收取，適用於以小時為單位的借閱期限。 ",
            en: "This fee is charged at checkout/renewal time for each hour between the checkout/renewal date and due date for loans specified in hours. ",
        },
        hourly_charge_calendar_description: {
            'zh-tw': "若勾選，時費將使用日曆排除假期進行計算。若未勾選，費用將根據到期日前的時數直接計算。",
            en: "If checked, hourly charge will be calculated using the calendar to exclude holidays. If not checked, the fee will be calculated based on the number of hours until due, directly.",
        },
        library_selection_description: {
            'zh-tw': "選擇「所有圖書館」如果所有圖書館都使用此館藏類型。否則，選擇使用此館藏類型的特定圖書館。",
            en: "Select 'All libraries' if all libraries use this item type. Otherwise, select the specific libraries that use this item type.",
        },
        summary_override_description: {
            'zh-tw': "輸入摘要以覆蓋搜尋結果列表中的預設摘要。例如，對於網站類型的館藏項目：<a href=\"[856u]\">開啟網站</a> 將顯示在標題下方的連結。",
            en: "Enter a summary that will overwrite the default one in search results lists. Example, for a website itemtype: <a href=\"[856u]\">open site</a> will show the link just below the title.",
        },
    }
}
const bib_infomation = {
    'zh-tw': "",
    en: "",
    children: {
        manage_marc_record: {
            'zh-tw': "管理書目",
            en: "Manage Marc Record"
        },
        post_bib: {
            'zh-tw': "新增書目",
            en: "Add Record"
        },
        results: {
            'zh-tw': "結果",
            en: "Results"
        },
        Author: {
            'zh-tw': "作者",
            en: "Author"
        },
        Material_type: {
            'zh-tw': "資料類型",
            en: "Material type"
        },
        Language: {
            'zh-tw': "語言",
            en: "Language"
        },
        Series: {
            'zh-tw': "集叢名",
            en: "Series"
        },
        Publication_details: {
            'zh-tw': "出版詳細資料",
            en: "Publication details"
        },
        Description: {
            'zh-tw': "描述",
            en: "Description"
        },
        Edition: {
            'zh-tw': "編輯",
            en: "Edition"
        },
        Other_title: {
            'zh-tw': "其他提名",
            en: "Other title"
        },
        ISBN: {
            'zh-tw': "ISBN",
            en: "ISBN"
        },
        location: {
            'zh-tw': "位置",
            en: "Location"
        },
        No_items: {
            'zh-tw': "沒有館藏",
            en: "No items"
        },
        borrowed: {
            'zh-tw': "已借出",
            en: "Borrowed"
        },
        available: {
            'zh-tw': "可借出",
            en: "available"
        },
        item: {
            'zh-tw': "館藏",
            en: "Item"
        },
        import_bibliography_date: {
            'zh-tw': "匯入書目日期",
            en: "Import Bibliography Date",
        },
        time_end: {
            'zh-tw': "結束時間",
            en: "Time End",
        },
        time_start: {
            'zh-tw': "開始時間",
            en: "Time Start",
        },
        bib_translator: {
            'zh-tw': "譯者",
            en: "Bibliographic Translator",
        },
        specification: {
            'zh-tw': '規格',
            en: 'Specification',
        },
    }
}

const language_koha = {
    'zh-tw': "KOHA",
    en: "KOHA",
    children: {
        authorized_category_management: authorized_category_management,
        authorized_category_values_management: authorized_category_values_management,
        library: library,
        item_types_management: item_types_management,
        bib_infomation: bib_infomation,
    }



}


export {
    language_koha
}